module.exports = __webpack_public_path__ + "img/checkout-cancel.cc523fd.webp";